import { render, staticRenderFns } from "./PriceCategoriesForSecondAgent.vue?vue&type=template&id=6dd225f5&scoped=true&"
import script from "./PriceCategoriesForSecondAgent.vue?vue&type=script&lang=js&"
export * from "./PriceCategoriesForSecondAgent.vue?vue&type=script&lang=js&"
import style0 from "./PriceCategoriesForSecondAgent.vue?vue&type=style&index=0&id=6dd225f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd225f5",
  null
  
)

export default component.exports